// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IdWc","top":"styles_top__gtEtF"};